import { UnifiedBallotStatus } from "../../../../../shared/enums/unified-ballot-status-enum";



export interface ISdBallotDetailDto {
    ballotId: number;
    projectId: number;
    ballotEndDate?: Date | null;
    ballotStartDate?: Date | null;
    negativeVotes?: number;
    noResponseVotes?: number;
    positiveVotes?: number;
    totalEligibleVoters?: number;
    ballotResolution: string;
    ballotStatusId: string;
    ballotStatusDisplayText: string;
    unifiedBallotStatusId?: UnifiedBallotStatus;
    unifiedBallotStatusDisplayText?: string;
    designation: string;
    publicationTitle: string;
    isJoint: boolean;
    committeeTitle: string;
    committeeCode: string;
    committeeProjectManagerName?: string;
    committeeProjectManagerEmail?: string;
    projectNumber: string;
    projectType: string;
    notes?: string;
    finalisedTime?: Date | null;
    finalisedByName?: string | null;
    finalisedByEmail?: string | null;
}


export enum IBallotStatus {
  PBS_CREATED = "PBS_CREATED",
  PBS_PENDING_CLOSURE = "PBS_PENDING_CLOSURE",
  PBS_DEFERRED = "PBS_DEFERRED",
  PBS_ON_HOLD = "PBS_ON_HOLD",
  PBS_SCHEDULED = "PBS_SCHEDULED",
  PBS_OPEN = "PBS_OPEN",
  PBS_DECISION_PENDING = "PBS_DECISION_PENDING",
  PBS_REVIEW_COMPLETE = "PBS_REVIEW_COMPLETE",
  PBS_PENDING_FINALISED_APPROVAL = "PBS_PENDING_FINALISED_APPROVAL"
}
